import { Box, Flex, HStack, Image, Link, Text } from '@chakra-ui/react';

import { social } from '$shared/social';
import logo from '$assets/logo.svg';

const items = [
  { href: `mailto:${social.email}`, label: 'Email', external: false },
  { href: social.github, label: 'GitHub', external: true },
  { href: social.linkedin, label: 'LinkedIn', external: true },
  { href: social.resume, label: 'Currículo', external: true },
];

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <Box
      as="footer"
      mt="8"
      pt="12"
      borderTopWidth="1px"
      borderColor="line.subtle"
    >
      <Flex
        direction={{ base: 'column', md: 'row' }}
        justify="space-between"
        align={{ base: 'start', md: 'center' }}
        gap="20px"
      >
        <HStack spacing="14px" align="center">
          <Image src={logo.src} alt="Logo" w="50px" />
        </HStack>

        <Flex gap="20px" wrap="wrap">
          {items.map((item) => (
            <Link
              key={item.label}
              href={item.href}
              isExternal={item.external}
              fontSize="14px"
              color="text.muted"
              _hover={{ color: 'accent.500' }}
              transition="color 0.2s ease"
            >
              {item.label} {item.external ? '↗' : ''}
            </Link>
          ))}
        </Flex>
      </Flex>

      <Text
        mt="24px"
        fontFamily="mono"
        fontSize="11px"
        letterSpacing="0.08em"
        color="text.faint"
        textTransform="uppercase"
      >
        © {year} Silvano Marques
      </Text>
    </Box>
  );
}
